import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
  title2: string
}

const TaxiAppServices: React.FC<Props> = ({ title, title2 }) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 mb-50">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Book now ride late" />
              <KEYBlue text="Car Pooling" />
              <KEYBlue text="Favourite destinations" />
              <KEYBlue text="Smart wallet" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Split charges" />
              <KEYBlue text="Inbuilt Messenger" />
              <KEYBlue text="Voice Recognition" />
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">{title2}</h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Online support" />
              <KEYBlue text="Rate customers" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TaxiAppServices
